import React from 'react';
import Style from './style.scss'
import Cx from 'classnames';
import styled from 'styled-components';

const StyledFooterDiv = styled.div`
    color:${props => props.theme.textColor};
    a {
        color:${props => props.theme.textColor};
    }
    a:hover {
        color:${props => props.theme.textColor};
    }
`;
class Footer extends React.Component {

    render() {
        return (

            <StyledFooterDiv tabIndex='0' aria-label='Help Desk software by Sys Aid' className={Style.footerWrapper} role="contentinfo">
                <span className={Cx('iconIssue', 'footerIcon', Style.footerIcon)}></span>
                <span>Help Desk Software by <a target="_blank" href="http://www.sysaid.com?adgrp=SysAid">SysAid</a></span>
            </StyledFooterDiv>
        )
    }
}


export default Footer;






// WEBPACK FOOTER //
// ./components/Footer/index.js